import InternFrame from 'components/InternFrame'
import React from 'react'
import Colors from 'utils/Colors'

import Container from './styles'

function BuildScoreData(props) {
  const { score } = props
  const getColor = (scorePoints) => {
    let color = scorePoints < 600 ? Colors.red : Colors.green
    if (!scorePoints) color = 'inherit'
    return color
  }
  return (
    <InternFrame title="Pontuação de score de crédito" color={getColor(score)}>
      <Container>
        <span>Pontuação: </span>
        {score}
      </Container>
    </InternFrame> 
  )
}

export default BuildScoreData
